module.exports = __webpack_public_path__ + "img/gang.aa74e64a.jpg";